import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType, GaTrackingStringConstantEnum } from '../../constants';
import get from 'lodash.get';
import { GaTrackingHelpersService } from '~shared/modules/ga-tracking/utils/ga-tracking-helpers.service';

export class GATrackingCartUpdateEvent implements GATrackingEvent {

  constructor(
    private offers: any[],
    private recommendation: boolean,
  ) {
  }

  public updateValidOffers(offers: any[]): void {
    this.offers = offers;
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.CartUpdate;
  }

  getPayload(): GATrackingEventPayload {
    const products = this.offers.map((offer) => {
      const categoryTree = get(offer, 'trackingData.categoryTree', '');
      const dimension29 = GaTrackingHelpersService.getReferencePriceTypeFromOffer(offer);
      const dimension31 = get(offer, 'trackingData.dimension31', 0);

      return {
        name: get(offer, 'item.name', ''),
        id: get(offer, 'item.id', ''),
        price: get(offer, 'price.total', ''),
        quantity: get(offer, 'quantity', ''),
        category: categoryTree.length > 0 ? categoryTree.join('/') : '',
        dimension42: get(offer, 'trackingData.dimension42', 0),
        dimension14: get(offer, 'trackingData.volumePricingShown', 'No'),
        dimension27: get(offer, 'trackingData.offerType', 'other'),
        dimension22: get(offer, 'trackingData.otherOffersShown', 'No'),
        dimension12: get(offer, 'trackingData.onSale', false),
        dimension15: get(offer, 'trackingData.sellerName', ''),
        dimension32: get(offer, 'trackingData.EECLabel', GaTrackingStringConstantEnum.NoEECLabel),
        dimension33: this.recommendation ? GaTrackingStringConstantEnum.Yes : GaTrackingStringConstantEnum.No,
        dimension43: get(offer, 'trackingData.dimension43', '0'),
        ...(!!dimension29 ? { dimension29 } : {}),
        ...(!!dimension31 ? { dimension31 } : {}),
        dimension51: get(offer, 'trackingData.dimension51', GaTrackingStringConstantEnum.No),
        dimension52: get(offer, 'trackingData.dimension52', GaTrackingStringConstantEnum.No),
        dimension53: get(offer, 'trackingData.dimension53', GaTrackingStringConstantEnum.No),
        dimension54: get(offer, 'trackingData.dimension54', ''),
        dimension58: get(offer, 'trackingData.dimension58', GaTrackingStringConstantEnum.No),
        service_price: get(offer, 'trackingData.servicePrice', '0')
      };
    });

    return {
      event: GaTrackingEventName.CartUpdate,
      label: GATrackingEventType.CartUpdate,
      gtmCustom: {
        ecommerce: {
          products
        }
      }
    };
  }
}
